<template>
  <header class="Header Header_withTitle" role="banner">
    <div class="Header_wrapper">
      <h2 class="Header_title">J'évalue mon logement</h2>
      
      <h2 class="Header_count" :key="currentIndex"><transition name="bottom" mode="out-in" appear><span>{{ currentIndex }}</span></transition>/{{ currentLength }}</h2>
      
      <router-link :to="{ name: 'home' }" @click.native="$gtm.trackEvent({ category: 'button_qualiscore_tunnel', action: 'click', label: 'fermeture_tunnel', value: quizIndex.survey + '_' + (quizIndex.survey == 'qualiscore' ? Number(quizIndex.index) + 1 : quizIndex.index ) })"><button><i class="far fa-times"></i></button></router-link>
    </div>
  </header>
</template>

<script>
  import { mapActions, mapState } from 'vuex'

  export default {
    name: "HeaderQuiz",
    computed: {
      ...mapState([
        'quizIndex',
        'quiz'
      ]),
      datas()
      {
        let questions = this.quiz.screening.questions.concat(this.quiz.qualiscore.questions)
        let results = []

        questions.forEach(question => {
          if(question.visible == 1 && !question.condition)
            results.push(question)
        })

        return results
      }
    },
    methods: {
      ...mapActions([
        'setQuizIndex'
      ])
    },
    watch: {
      quiz()
      {
        console.log('quiz')

        this.$nextTick( () => {
          let count = 0
          this.quiz.screening.questions.forEach( question => {
            if(question.visible != 0 && !question.subquestions)
              count = count + 1
          })
          this.screeningLenght = count

          count = 0
          this.quiz.qualiscore.questions.forEach( question => {
            if(question.visible != 0 && !question.subquestions){
              count = count + 1
            }
          })
          // -1 sur le count car la question 2 du qualiscore est doublée (si locataire ou propriétaire)
          this.qualiscoreLenght = count - 1

          if(this.quizIndex.survey == 'qualiscore')
            this.currentLength = this.qualiscoreLenght
          else
            this.currentLength = this.screeningLenght
        })
      },
      quizIndex()
      {
        if(this.quizIndex.survey == 'qualiscore'){
          this.currentIndex = Number(this.quizIndex.index) + 1
          this.currentLength = this.qualiscoreLenght
        }
        else
        {
          this.currentIndex = Number(this.quizIndex.index)
          this.currentLength = this.screeningLenght
        }
      }
    },
    data() {
      return {
        currentLength: 0,
        currentIndex: 1,
        withCount: false,
        qualiscoreLenght: 0,
        screeningLenght: 0
      }
    },
    mounted()
    {
      
    }
  }
</script>

<style lang="stylus" scoped>
.Header

  position fixed
  top 0px
  left 0px
  right 0px
  height 60px
  box-sizing border-box
  width 100%
  z-index 100

  &_wrapper

    border-bottom 1px solid $n1
    margin 0px 80px
    height 100%
    display flex
    flex-direction row
    align-items center
    position relative
    justify-content space-between

    @media $medium

      margin 0px $s-xs

    h2

      letter-spacing -0.3px 
      font-size 14px
      font-weight 500
      color $blue
      position absolute
      top 50%
      left 0px
      transform translateY(-50%)
      transition 1s $ease

      span

        display inline-block

        &.bottom-enter-active, &.bottom-leave-active
          transition transform 0.6s $ease, opacity 0.6s $ease!important

        &.bottom-enter
          transform translateY(10px)!important
          opacity 0

        &.bottom-leave-to
          opacity 0
          transform translateY(-10px)!important

    .Header_title

      opacity 0
      transform translateY(-50%) translateX(30px)
      transition-duration 0.3s

    .Header_count

      opacity 1
      transform translateY(-50%) translateX(0px)
      
    button

      appearance none
      border 0px
      font-size 18px
      color $s1
      background-color transparent
      cursor pointer
      padding 10px 0px 10px 10px
      position absolute
      top 50%
      right 0px
      transform translateY(-50%)

  &_withTitle

    .Header_title

      opacity 1
      transform translateY(-50%) translateX(0)

    .Header_count

      opacity 0
      transform translateY(-50%) translateX(30px)
      transition-duration 0.3s
      

</style>